enum EAlertType {
  INFO = 0,
  WARNING = 1,
  ERROR = 2,
  SUCCESS = 3,
}

export default EAlertType;
